var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9166 17.4167V16.435C13.7348 16.1749 15.3071 15.1526 16.2995 13.7022C18.7874 13.3594 20.1666 11.2043 20.1666 8.25V5.5C20.1666 4.48748 19.3458 3.66667 18.3333 3.66667H17.1713C16.8543 3.11868 16.2618 2.75 15.5833 2.75H6.41658C5.73799 2.75 5.14551 3.11868 4.82852 3.66667H3.66659C2.65406 3.66667 1.83325 4.48748 1.83325 5.5V8.25C1.83325 11.2043 3.21245 13.3594 5.70035 13.7022C6.69272 15.1526 8.26504 16.1749 10.0833 16.435V17.4167H9.16659C8.15406 17.4167 7.33325 18.2375 7.33325 19.25H14.6666C14.6666 18.2375 13.8458 17.4167 12.8333 17.4167H11.9166ZM3.66659 5.5H4.58325V10.0833C4.58325 10.5029 4.62353 10.9131 4.70043 11.3103C4.02434 10.7018 3.66659 9.65366 3.66659 8.25V5.5ZM17.4166 5.5V10.0833C17.4166 10.5029 17.3763 10.9131 17.2994 11.3103C17.9755 10.7018 18.3333 9.65366 18.3333 8.25V5.5H17.4166ZM6.41658 10.0833V4.58333H15.5833V10.0833C15.5833 12.6146 13.5312 14.6667 10.9999 14.6667C8.46861 14.6667 6.41658 12.6146 6.41658 10.0833Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCup);
export default __webpack_public_path__ + "static/media/cup.16b594f89b73dbc9e5bd550c2b15d57f.svg";
export { ForwardRef as ReactComponent };